// extracted by mini-css-extract-plugin
module.exports = {"author-details":"_2D4rP"};